<template>
  <q-page>
    <div>  
      <List></List>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import List from '@/components/MaintenanceSchedule/List.vue'
export default {
  name: 'User',
  components: {
    List,
  },
  data: function () {
    return {
      
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
